import React, { FunctionComponent } from "react"

interface MessageIconProps {}

const MessageIcon: FunctionComponent<MessageIconProps> = () => {
  return (
    <svg
      width="54"
      height="53"
      viewBox="0 0 54 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_721_568)">
        <path
          d="M40 27.3333C40 28.0995 39.6956 28.8343 39.1539 29.3761C38.6121 29.9179 37.8773 30.2222 37.1111 30.2222H19.7778L14 36V12.8889C14 12.1227 14.3044 11.3879 14.8461 10.8461C15.3879 10.3044 16.1227 10 16.8889 10H37.1111C37.8773 10 38.6121 10.3044 39.1539 10.8461C39.6956 11.3879 40 12.1227 40 12.8889V27.3333Z"
          fill="#1EB482"
          stroke="#1EB482"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_721_568"
          x="-4.66667"
          y="-5.33333"
          width="63.3333"
          height="63.3333"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1.66667"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_721_568"
          />
          <feOffset dy="3.33333" />
          <feGaussianBlur stdDeviation="6.66667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.117647 0 0 0 0 0.705882 0 0 0 0 0.509804 0 0 0 0.32 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_721_568"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_721_568"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default MessageIcon
